<template>
  <div id="cv-edit">
    <SideBar
      :cvid="cv_id"
      v-on:show-prev="previewDialog=true; updateed  += 1"

    ></SideBar>

    <VtoolBarHome></VtoolBarHome>

    <!-- <v-btn
         @click="goToCvPreview(modelObjects.id)"
         class="fab-container"
         fixed
         top
         left
         dark
         fab
         large
         color=info
         >
         <v-icon x-large>visibility</v-icon>
         </v-btn> -->

    <!-- <v-tooltip bottom>
         <v-btn
         @click="goToCvPreview(modelObjects.id)"
         dark
         fab
         large
         color=info
         >
         <v-icon x-large>picture-as-pdf</v-icon>
         </v-btn>
         <span>Pré-visualiser</span>
         </v-tooltip> -->



    <v-content>


      <v-container grid-list-xl>

        <MailClient></MailClient>
        <MenuDialer :cvid="cv_id"></MenuDialer>

        <v-dialog persistent lazy v-model="getLoadingAllState" width="400px">
          <v-card>
            <v-card-text class="text-xs-center">
              <v-progress-circular
                :size="70"
                :width="7"
                color="purple"
                indeterminate
              ></v-progress-circular>
            </v-card-text>
            <v-layout align-center justify-center>
              <v-card-title primary-title>
                <div>
                  <h5 class="headline">Chargement de vos données.</h5>
                  <span class="subheading text-xs-center">Veuillez patientez...</span>
                </div>
              </v-card-title>
            </v-layout>

          </v-card>
        </v-dialog>


        <v-layout justify-center row wrap>


          <v-flex xs12 lg10 pa-4>

            <div
              v-if="!changeCvNameDialog"
              class="text-xs-center ml-5"
            >
              <h4 class="headline"> Vous éditez le CV :  <span class="font-weight-bold"> {{ vuexCvModel.name }} </span></h4>

              <v-btn
                outline
                round
                color="primary"
                dark
                @click.stop="changeCvNameDialog = true"
              >
                <v-icon dark left>edit</v-icon>
                <span>Renommer ce CV</span>
              </v-btn>
            </div>

            <div v-else>
              <v-form
                @submit.prevent="updateCvModelObject({ 'cvid':vuexCvModel.id, 'data_sent': {'name': vuexCvModel.name} });changeCvNameDialog = false"
              >
                <v-layout d-inline-flex align-center justify-center ml-5 pl-5>

                  <v-text-field class="title" label="Nommer ce CV:"
                                v-model="cvModel"
                                v-validate="'max:20'"
                                data-vv-name='change-cv-name'
                                :error-messages="errors.collect('change-cv-name')"
                                data-vv-delay="200"
                  >
                  </v-text-field>
                  <v-btn
                    flat icon
                    color="primary"
                    type="submit"
                  >
                    <v-icon>done</v-icon>
                  </v-btn>
                  <v-btn
                    flat icon
                    color="warning"
                    v-on:click="changeCvNameDialog = false"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>

                </v-layout>

              </v-form>
            </div>

          </v-flex>

          <v-flex xs12 lg10>
            <PersInfosComponent
              :cv_id='cv_id'
            />
          </v-flex>

          <v-flex xs12 lg10>
            <PersSumComponent
              :cv_id='cv_id'
            />
          </v-flex>

          <v-flex xs12 lg10>
            <WorkItems
              :cv_id='cv_id'
            />
          </v-flex>

          <v-flex xs12 lg10>
            <EduItems
              :cv_id='cv_id'
            />
          </v-flex>

          <v-flex xs12 lg10>
            <SkillItems
              :cv_id='cv_id'
            />
          </v-flex>

          <v-flex xs12 lg10>
            <LangItems
              :cv_id='cv_id'
            />
          </v-flex>

          <v-flex xs12 lg10>
            <HobbyItem
              :cv_id='cv_id'
            />
          </v-flex>

        </v-layout>

      </v-container>
    </v-content>



  </div>

</template>

<script>

 import VtoolBarHome from '../components/VtoolBarHome';
 import SideBar from '../components/SideBar';
 import PersInfosComponent from '../components/PersInfosComponent';
 import PersSumComponent from '../components/PersSumComponent';
 import EduItems from '../components/EduItems';
 import WorkItems from '../components/WorkItems';
 import SkillItems from '../components/SkillItems';
 import LangItems from '../components/LangItems';
 import HobbyItem from '../components/HobbyItems';
 import MailClient from '../components/MailClient';
 import MenuDialer from '../components/MenuDialer';
 // import CvPreviewComponent from '../components/CvPreviewComponent';
 import { mapActions, mapGetters, mapState } from 'vuex';


 export default {
   data() {
     return {
       changeCvNameDialog: false,
       api_url: '/api/cv/' + this.cv_id + '/',
       modelObject: {},
       newModelObject: function() {
         return null;
       },
       isLoading: false,
       previewDialog: false,
       updateed: 0,
     }
   },
   props: ['cv_id'],
   components: {
     VtoolBarHome,
     PersInfosComponent,
     PersSumComponent,
     WorkItems,
     EduItems,
     SkillItems,
     LangItems,
     HobbyItem,
     SideBar,
     MailClient,
     MenuDialer,
   },
   methods: {
     goToCvPreview(cvId) {
       this.$router.push({ name: 'cvPreview', params: { cv_id:cvId } })
     },
     ...mapActions('sectionLayout', [
       'getVuexLayoutModelObject',
       'updateVuexLayoutModelObject',
     ]),
     ...mapActions('loading', [
       'initLoading',
     ]),
     ...mapActions('cvVuex', [
       'getCvModelObject',
       'updateCvModelObject',
     ]),
   },
   computed: {
     cvModel: {
       get() {
         return this.$store.state.cvVuex.vuexCvModel['name'];
       },
       set(value) {
         // NOTE : on envoie un objet qui est ensuite décomposé dans la mutation MODEL_OBJECT_2
         // noter le namespace 'module/MUTATION'
         this.$store.commit('cvVuex/CV_MODEL_UPDATE_2', { 'name':  value })
       }
     },
     ...mapGetters('loading', [
       'getLoadingAllState',
     ]),
     ...mapState('sectionLayout', [
       'vuexLayoutModelObject',
       'getErrorLayout',
       'updateLayoutError',
       'vuexIsLoadingLayout'
     ]),
     ...mapState('cvVuex', [
       'vuexCvModel',
     ]),
   },
   mounted: function() {
     console.log('++++++++ Mounted +++++' + this.cv_id);
     this.getCvModelObject({'cvid': this.cv_id});
     this.getVuexLayoutModelObject({'cv_id': this.cv_id});
     // Lors du chargement de cette vue, on initialise le Loading à false
     // le widget loader va donc tourner.
     // Lors du chargement des components fils, ce loading disparaitra car
     // chaque components s'enregistrera comme ayant fini son chargement.
     this.initLoading();
     console.log('mapstate INITIAL loading all : ' + this.getLoadingAllState)
   }
 }

</script>

<style>

.fab-container {
  margin-top: 8em;
  margin-left: 4em;
}
</style>
